import React, { useState, useEffect } from "react";
import "./Payouts.css";
import PayoutsLoadingSkeleton from "../components/skeletionLoaders/PayoutsSkeleton";
const payoutData = [
  {
    id: "payout_001",
    agentID: "694f169ed960a66a556866f6",
    clientInvolved: "695327362212b30dc4732001",
    clientName: "Monkey Shop",
    payoutType: "subscriptionCommission",
    expectedPayoutDate: "2025-01-05",
    amount: 15000,
    payoutDate: "2025-01-06",
    paymentMethod: "bankTransfer",
    transactionReference: "TXN-001",
    notes: "January subscription payout",
    isPayoutCompleted: true,
    status: "completed",
  },
  {
    id: "payout_002",
    agentID: "694f169ed960a66a556866f6",
    clientInvolved: "695327362212b30dc4732002",
    clientName: "Kao Fashion",
    payoutType: "purchaseCommission",
    expectedPayoutDate: "2025-01-10",
    amount: 22000,
    payoutDate: null,
    paymentMethod: "bankTransfer",
    transactionReference: null,
    notes: "Awaiting POS delivery confirmation",
    isPayoutCompleted: false,
    status: "pending",
  },
  {
    id: "payout_003",
    agentID: "694f169ed960a66a556866f6",
    clientInvolved: "695327362212b30dc4732003",
    clientName: "Bolu Stores",
    payoutType: "leaseCommission",
    expectedPayoutDate: "2025-01-15",
    amount: 18000,
    payoutDate: "2025-01-16",
    paymentMethod: "check",
    transactionReference: "CHK-88231",
    notes: "POS hardware lease",
    isPayoutCompleted: true,
    status: "completed",
  },
  {
    id: "payout_004",
    agentID: "694f169ed960a66a556866f6",
    clientInvolved: "695327362212b30dc4732004",
    clientName: "Emma Interiors",
    payoutType: "referralBonus",
    expectedPayoutDate: "2025-01-20",
    amount: 10000,
    payoutDate: null,
    paymentMethod: "paypal",
    transactionReference: null,
    notes: "Referral bonus under review",
    isPayoutCompleted: false,
    status: "processing",
  },
  {
    id: "payout_005",
    agentID: "694f169ed960a66a556866f6",
    clientInvolved: "695327362212b30dc4732005",
    clientName: "Nordic Home",
    payoutType: "subscriptionCommission",
    expectedPayoutDate: "2025-01-25",
    amount: 14000,
    payoutDate: "2025-01-25",
    paymentMethod: "bankTransfer",
    transactionReference: "TXN-009",
    notes: "Auto payout",
    isPayoutCompleted: true,
    status: "completed",
  },
  {
    id: "payout_006",
    agentID: "694f169ed960a66a556866f6",
    clientInvolved: "695327362212b30dc4732006",
    clientName: "City Mart",
    payoutType: "purchaseCommission",
    expectedPayoutDate: "2025-02-02",
    amount: 32000,
    payoutDate: null,
    paymentMethod: "bankTransfer",
    transactionReference: null,
    notes: "Bulk POS purchase",
    isPayoutCompleted: false,
    status: "pending",
  },
  {
    id: "payout_007",
    agentID: "694f169ed960a66a556866f6",
    clientInvolved: "695327362212b30dc4732007",
    clientName: "Greenfield Pharmacy",
    payoutType: "subscriptionCommission",
    expectedPayoutDate: "2025-02-05",
    amount: 12000,
    payoutDate: null,
    paymentMethod: "bankTransfer",
    transactionReference: null,
    notes: "New subscription",
    isPayoutCompleted: false,
    status: "processing",
  },
  {
    id: "payout_008",
    agentID: "694f169ed960a66a556866f6",
    clientInvolved: "695327362212b30dc4732008",
    clientName: "Urban Wear",
    payoutType: "leaseCommission",
    expectedPayoutDate: "2025-02-08",
    amount: 20000,
    payoutDate: "2025-02-08",
    paymentMethod: "bankTransfer",
    transactionReference: "TXN-014",
    notes: "Lease payout settled",
    isPayoutCompleted: true,
    status: "completed",
  },
  {
    id: "payout_009",
    agentID: "694f169ed960a66a556866f6",
    clientInvolved: "695327362212b30dc4732009",
    clientName: "Fresh Basket",
    payoutType: "subscriptionCommission",
    expectedPayoutDate: "2025-02-12",
    amount: 11000,
    payoutDate: null,
    paymentMethod: "bankTransfer",
    transactionReference: null,
    notes: "Pending billing cycle",
    isPayoutCompleted: false,
    status: "pending",
  },
  {
    id: "payout_010",
    agentID: "694f169ed960a66a556866f6",
    clientInvolved: "695327362212b30dc4732010",
    clientName: "Silverline Electronics",
    payoutType: "purchaseCommission",
    expectedPayoutDate: "2025-02-15",
    amount: 45000,
    payoutDate: "2025-02-16",
    paymentMethod: "bankTransfer",
    transactionReference: "TXN-021",
    notes: "Bulk hardware purchase",
    isPayoutCompleted: true,
    status: "completed",
  },

  // ---- extra variety ----
  {
    id: "payout_011",
    agentID: "694f169ed960a66a556866f6",
    clientInvolved: "695327362212b30dc4732011",
    clientName: "Corner Bookstore",
    payoutType: "subscriptionCommission",
    expectedPayoutDate: "2025-02-18",
    amount: 9000,
    payoutDate: null,
    paymentMethod: "bankTransfer",
    transactionReference: null,
    notes: "Payment failed due to chargeback",
    isPayoutCompleted: false,
    status: "failed",
  },
  {
    id: "payout_012",
    agentID: "694f169ed960a66a556866f6",
    clientInvolved: "695327362212b30dc4732012",
    clientName: "Prime Furniture",
    payoutType: "referralBonus",
    expectedPayoutDate: "2025-02-20",
    amount: 25000,
    payoutDate: "2025-02-20",
    paymentMethod: "paypal",
    transactionReference: "PAY-334455",
    notes: "Referral bonus paid",
    isPayoutCompleted: true,
    status: "completed",
  },
  {
    id: "payout_013",
    agentID: "694f169ed960a66a556866f6",
    clientInvolved: "695327362212b30dc4732013",
    clientName: "Mega Superstore",
    payoutType: "purchaseCommission",
    expectedPayoutDate: "2025-02-22",
    amount: 52000,
    payoutDate: null,
    paymentMethod: "bankTransfer",
    transactionReference: null,
    notes: "Invoice verification pending",
    isPayoutCompleted: false,
    status: "processing",
  },
  {
    id: "payout_014",
    agentID: "694f169ed960a66a556866f6",
    clientInvolved: "695327362212b30dc4732014",
    clientName: "Daily Needs",
    payoutType: "subscriptionCommission",
    expectedPayoutDate: "2025-02-25",
    amount: 13000,
    payoutDate: "2025-02-25",
    paymentMethod: "bankTransfer",
    transactionReference: "TXN-033",
    notes: "Auto payout success",
    isPayoutCompleted: true,
    status: "completed",
  },
  {
    id: "payout_015",
    agentID: "694f169ed960a66a556866f6",
    clientInvolved: "695327362212b30dc4732015",
    clientName: "Smart Gadgets",
    payoutType: "leaseCommission",
    expectedPayoutDate: "2025-02-28",
    amount: 21000,
    payoutDate: null,
    paymentMethod: "check",
    transactionReference: null,
    notes: "Awaiting lease confirmation",
    isPayoutCompleted: false,
    status: "pending",
  },
  {
    id: "payout_016",
    agentID: "694f169ed960a66a556866f6",
    clientInvolved: "695327362212b30dc4732016",
    clientName: "Happy Foods",
    payoutType: "subscriptionCommission",
    expectedPayoutDate: "2025-03-02",
    amount: 10000,
    payoutDate: null,
    paymentMethod: "bankTransfer",
    transactionReference: null,
    notes: "First subscription payout",
    isPayoutCompleted: false,
    status: "processing",
  },
  {
    id: "payout_017",
    agentID: "694f169ed960a66a556866f6",
    clientInvolved: "695327362212b30dc4732017",
    clientName: "Elite Fashion",
    payoutType: "purchaseCommission",
    expectedPayoutDate: "2025-03-05",
    amount: 38000,
    payoutDate: "2025-03-06",
    paymentMethod: "bankTransfer",
    transactionReference: "TXN-041",
    notes: "POS upgrade purchase",
    isPayoutCompleted: true,
    status: "completed",
  },
  {
    id: "payout_018",
    agentID: "694f169ed960a66a556866f6",
    clientInvolved: "695327362212b30dc4732018",
    clientName: "Local Pharmacy",
    payoutType: "subscriptionCommission",
    expectedPayoutDate: "2025-03-08",
    amount: 9500,
    payoutDate: null,
    paymentMethod: "bankTransfer",
    transactionReference: null,
    notes: "Billing retry scheduled",
    isPayoutCompleted: false,
    status: "failed",
  },
  {
    id: "payout_019",
    agentID: "694f169ed960a66a556866f6",
    clientInvolved: "695327362212b30dc4732019",
    clientName: "Tech Hub",
    payoutType: "referralBonus",
    expectedPayoutDate: "2025-03-10",
    amount: 30000,
    payoutDate: null,
    paymentMethod: "paypal",
    transactionReference: null,
    notes: "Referral awaiting approval",
    isPayoutCompleted: false,
    status: "processing",
  },
  {
    id: "payout_020",
    agentID: "694f169ed960a66a556866f6",
    clientInvolved: "695327362212b30dc4732020",
    clientName: "Home Essentials",
    payoutType: "subscriptionCommission",
    expectedPayoutDate: "2025-03-12",
    amount: 12500,
    payoutDate: "2025-03-12",
    paymentMethod: "bankTransfer",
    transactionReference: "TXN-055",
    notes: "Monthly subscription payout",
    isPayoutCompleted: true,
    status: "completed",
  },
];

const Payouts = ({ agentData }) => {
  const [copiedLink, setCopiedLink] = useState(false);
  const [selectedPayout, setSelectedPayout] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [agentInfo, setAgentInfo] = useState(null);
  const [completedPayouts, setCompletedPayouts] = useState([]);
  const [completedPayoutsToShow, setCompletedPayoutsToShow] = useState([]);
  const [pendingPayouts, setPendingPayouts] = useState([]);
  const [payoutSummary, setPayoutSummary] = useState({});

  useEffect(() => {
    let agentInfoFromStorage = localStorage.getItem("agentData");
    if (!agentInfoFromStorage) {
      setIsLoading(false);
      window.location.href = "/sign-in";
      return;
    }
    setAgentInfo(JSON.parse(agentInfoFromStorage));

    const payoutsDataFromBackend = fetchPayoutData();
    console.log("Agent Info:", JSON.parse(agentInfoFromStorage));
  }, []);

  const fetchPayoutData = async () => {
    try {
      let storedAgent = localStorage.getItem("agentData");
      if (!storedAgent) {
        alert("Agent not logged in. Please sign in again.");
        window.location.href = "/sign-in";
        return;
      }
      let storedAgentID = JSON.parse(storedAgent)._id;

      let url = process.env.REACT_APP_Back_end_api_root + "/marketingAgentApp/getAgentPayouts/" + storedAgentID;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      if (response.status === 404) {
        /*  alert(data.message || "Payout data not found");
        return; */
      }
      if (!response.ok) {
        throw new Error(data.message || "Failed to fetch payout data");
      }
      console.log("Fetched payout data:", data.payouts);
      // Process and set payout data here
      const completed = data.payouts.filter((p) => p.isPayoutCompleted);
      const pending = data.payouts.filter((p) => !p.isPayoutCompleted);
      setCompletedPayouts(completed);
      if (completed.length > 10) {
        setCompletedPayoutsToShow(completed.slice(0, 10));
      } else {
        setCompletedPayoutsToShow(completed);
      }
      setPendingPayouts(pending);
      const totalEarned = payoutData.reduce((sum, p) => sum + p.amount, 0);
      const paidOut = completed.reduce((sum, p) => sum + p.amount, 0);
      const pendingPayout = pending.reduce((sum, p) => sum + p.amount, 0);
      const accruedCommission = payoutData
        .filter((p) => {
          const payoutDate = new Date(p.payoutDate);
          const now = new Date();
          return payoutDate.getMonth() === now.getMonth() && payoutDate.getFullYear() === now.getFullYear();
        })
        .reduce((sum, p) => sum + p.amount, 0);

      setPayoutSummary({
        totalEarned,
        paidOut,
        pendingPayout,
        accruedCommission, // for this month commission
      });
    } catch (error) {
      console.error("Error fetching payout data:", error);
      alert("Failed to load payout data. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  const referralLink = `${agentInfo?.referralLink || "https://www.storelense.com/sign-up"}`; // this link will only give agent one time bonus when someone uses it to sign up

  const copyReferralLink = () => {
    navigator.clipboard.writeText(referralLink);
    setCopiedLink(true);
    setTimeout(() => setCopiedLink(false), 2000);
  };

  const shareViaWhatsApp = () => {
    const message = `Join StoreLense today and transform your retail business!. Sign up here: ${referralLink}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, "_blank");
  };

  const shareReferral = async () => {
    const message = `Join StoreLense and grow your retail business!
    
  Sign up here: ${referralLink}`;

    if (navigator.share) {
      try {
        await navigator.share({
          title: "Join StoreLense",
          text: message,
          url: referralLink,
        });
      } catch (e) {
        console.log("Share cancelled");
      }
    } else {
      window.location.href = `mailto:?subject=${encodeURIComponent("Join StoreLense")}&body=${encodeURIComponent(message)}`;
    }
  };

  const getStatusBadge = (status) => {
    const config = {
      completed: { label: "Completed", color: "#10b981", bg: "#d1fae5" },
      pending: { label: "Pending", color: "#f59e0b", bg: "#fef3c7" },
      processing: { label: "Processing", color: "#3b82f6", bg: "#dbeafe" },
      failed: { label: "Failed", color: "#ef4444", bg: "#fee2e2" },
    };
    const statusConfig = config[status] || config.pending;
    return (
      <span className='sl-agent-payout-status' style={{ color: statusConfig.color, background: statusConfig.bg }}>
        ● {statusConfig.label}
      </span>
    );
  };

  const totalCommissions =
    Number(agentInfo?.totalPurchaseCommissions) + Number(agentInfo?.totalLeaseCommissions) + Number(agentInfo?.totalSubscriptionCommissions);

  return (
    <>
      {isLoading ? (
        <PayoutsLoadingSkeleton />
      ) : (
        <div className='sl-agent-payouts-container'>
          {/* Header */}
          <div className='sl-agent-payouts-header'>
            <div>
              <h1>Payouts & Commissions</h1>
              <p>Track your earnings and manage payouts (showing test data) </p>
            </div>
          </div>

          {/* Summary Cards */}
          <div className='sl-agent-payout-summary-grid'>
            <div className='sl-agent-summary-card sl-agent-card-purple'>
              <div className='sl-agent-summary-icon'>💰</div>
              <div className='sl-agent-summary-content'>
                <p className='sl-agent-summary-label'>Total Earned</p>
                <h3 className='sl-agent-summary-value'>₦{payoutSummary?.totalEarned?.toLocaleString()}</h3>
                {/*     <span className='sl-agent-summary-trend'>+18% from last month</span> */}
              </div>
            </div>

            <div className='sl-agent-summary-card sl-agent-card-green'>
              <div className='sl-agent-summary-icon'>✓</div>
              <div className='sl-agent-summary-content'>
                <p className='sl-agent-summary-label'>Paid Out</p>
                <h3 className='sl-agent-summary-value'>₦{payoutSummary?.paidOut?.toLocaleString()}</h3>
                {/*    <span className='sl-agent-summary-trend'>Last payment: Dec 1</span> */}
              </div>
            </div>

            <div className='sl-agent-summary-card sl-agent-card-orange'>
              <div className='sl-agent-summary-icon'>⏳</div>
              <div className='sl-agent-summary-content'>
                <p className='sl-agent-summary-label'>Pending Payouts</p>
                <h3 className='sl-agent-summary-value'>₦{payoutSummary?.pendingPayout?.toLocaleString()}</h3>
                {/*   <span className='sl-agent-summary-trend'>Due: Jan 1, 2025</span> */}
              </div>
            </div>

            <div className='sl-agent-summary-card sl-agent-card-blue'>
              <div className='sl-agent-summary-icon'>📈</div>
              <div className='sl-agent-summary-content'>
                <p className='sl-agent-summary-label'>Accrued This Month</p>
                <h3 className='sl-agent-summary-value'>₦{payoutSummary?.accruedCommission?.toLocaleString()}</h3>
                {/*  <span className='sl-agent-summary-trend'>4 new commissions</span> */}
              </div>
            </div>
          </div>

          {/* Referral Section */}
          <div className='sl-agent-referral-section'>
            <div className='sl-agent-referral-card'>
              <div className='sl-agent-referral-header'>
                <div>
                  <h2>🔗 Your Referral Link</h2>
                  <p>Share your link and earn commissions on every successful referral</p>
                </div>
                <div className='sl-agent-referral-stats'>
                  <div className='sl-agent-ref-stat'>
                    <span className='sl-agent-ref-value'> {agentInfo?.clients.length || 0} </span>
                    <span className='sl-agent-ref-label'>Total Clients</span>
                  </div>
                  <div className='sl-agent-ref-stat'>
                    <span className='sl-agent-ref-value'> {agentInfo?.clients.filter((c) => c.status === "converted").length || 0} </span>
                    <span className='sl-agent-ref-label'>Conversions</span>
                  </div>
                </div>
              </div>

              <div className='sl-agent-referral-link-box'>
                <input type='text' value={referralLink} readOnly className='sl-agent-link-input' />
                <button className='sl-agent-copy-btn' onClick={copyReferralLink}>
                  {copiedLink ? "✓ Copied!" : "📋 Copy"}
                </button>
              </div>

              <div className='sl-agent-share-buttons'>
                <button className='sl-agent-share-btn sl-agent-whatsapp' onClick={shareViaWhatsApp}>
                  <span>📱</span> Share on WhatsApp
                </button>
                <button onClick={shareReferral} className='sl-agent-share-btn sl-agent-email'>
                  <span>📧</span> Share via Email
                </button>
                <button onClick={shareReferral} className='sl-agent-share-btn sl-agent-sms'>
                  <span>💬</span> Share via SMS
                </button>
              </div>
            </div>
          </div>

          {/* Main Content Grid */}
          <div className='sl-agent-payouts-grid'>
            {/* Pending Payments */}
            <div className='sl-agent-payouts-card'>
              <div className='sl-agent-card-header'>
                <h2>Pending Payments</h2>
                <span className='sl-agent-pending-count'>{pendingPayouts.length} items</span>
              </div>
              <div className='sl-agent-pending-list'>
                {pendingPayouts.map((payment) => (
                  <div key={payment.id} className='sl-agent-pending-item'>
                    <div className='sl-agent-pending-icon'>⏳</div>
                    <div className='sl-agent-pending-info'>
                      <h4>{payment.clientName}</h4>
                      <p className='sl-agent-pending-type'>
                        {payment.payoutType === "subscriptionCommission"
                          ? "Subscription Commission"
                          : payment.payoutType === "purchaseCommission"
                          ? "Purchase Commission"
                          : payment.payoutType === "leaseCommission"
                          ? "Lease Commission"
                          : "Referral Bonus"}
                      </p>
                      <p className='sl-agent-pending-date'>
                        Expected: {new Date(payment.expectedPayoutDate).toLocaleDateString("en-NG", { month: "short", day: "numeric", year: "numeric" })}
                      </p>
                    </div>
                    <div className='sl-agent-pending-amount'>₦{payment.amount.toLocaleString()}</div>
                  </div>
                ))}
              </div>
              <div className='sl-agent-pending-total'>
                <span>Total Pending</span>
                <strong>₦{pendingPayouts.reduce((sum, p) => sum + p.amount, 0).toLocaleString()}</strong>
              </div>
            </div>

            {/* Payout History */}
            <div className='sl-agent-payouts-card'>
              <div className='sl-agent-card-header'>
                <h2>Payout History</h2>
                <span className='sl-agent-history-count'>{completedPayouts.length} payouts </span>
              </div>
              <div className='sl-agent-history-list'>
                {completedPayoutsToShow.map((payout) => (
                  <div key={payout.id} className='sl-agent-history-item' onClick={() => setSelectedPayout(payout)}>
                    <div className='sl-agent-history-left'>
                      <div className='sl-agent-history-icon'>✓</div>
                      <div className='sl-agent-history-info'>
                        <h4>{new Date(payout.payoutDate).toLocaleDateString("en-NG", { month: "long", year: "numeric" })}</h4>
                        <p>
                          {payout.clientName} clients • {payout.transactionReference}
                        </p>
                      </div>
                    </div>
                    <div className='sl-agent-history-right'>
                      <div className='sl-agent-history-amount'>₦{payout.amount.toLocaleString()}</div>
                      {getStatusBadge(payout.status)}
                    </div>
                  </div>
                ))}
              </div>

              {completedPayouts.length > 10 && (
                <button className='sl-agent-view-all-btn' onClick={() => setCompletedPayoutsToShow(completedPayouts)}>
                  View All Payouts
                </button>
              )}
            </div>
          </div>

          {/* Commission Breakdown */}
          <div className='sl-agent-commission-breakdown'>
            <h2>Commission Breakdown</h2>
            <div className='sl-agent-breakdown-grid'>
              <div className='sl-agent-breakdown-item'>
                <div className='sl-agent-breakdown-header'>
                  <span className='sl-agent-breakdown-icon'>🎯</span>
                  <h4>Purchase Commissions</h4>
                </div>
                <div className='sl-agent-breakdown-value'>₦{Math.round(agentInfo?.totalPurchaseCommissions)}</div>
                <div className='sl-agent-breakdown-bar'>
                  <div
                    className='sl-agent-bar-fill'
                    style={{
                      width: `
                ${totalCommissions ? (Math.round(agentInfo?.totalPurchaseCommissions) / totalCommissions) * 100 : 0}%
                `,
                      background: "#667eea",
                    }}
                  ></div>
                </div>
              </div>

              <div className='sl-agent-breakdown-item'>
                <div className='sl-agent-breakdown-header'>
                  <span className='sl-agent-breakdown-icon'>📦</span>
                  <h4>Lease Commissions</h4>
                </div>
                <div className='sl-agent-breakdown-value'>₦{Math.round(agentInfo?.totalLeaseCommissions)} </div>
                <div className='sl-agent-breakdown-bar'>
                  <div
                    className='sl-agent-bar-fill'
                    style={{
                      width: `${totalCommissions ? (Math.round(agentInfo?.totalLeaseCommissions) / totalCommissions) * 100 : 0}%`,
                      background: "#10b981",
                    }}
                  ></div>
                </div>
              </div>

              <div className='sl-agent-breakdown-item'>
                <div className='sl-agent-breakdown-header'>
                  <span className='sl-agent-breakdown-icon'>🎁</span>
                  <h4>Subscription Bonuses</h4>
                </div>
                <div className='sl-agent-breakdown-value'>₦{Math.round(agentInfo?.totalSubscriptionCommissions)}</div>
                <div className='sl-agent-breakdown-bar'>
                  <div
                    className='sl-agent-bar-fill'
                    style={{
                      width: `${totalCommissions ? (Math.round(agentInfo?.totalSubscriptionCommissions) / totalCommissions) * 100 : 0}%`,
                      background: "#f59e0b",
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Payouts;
